import {t} from 'i18next';
import {useBookingState} from '../store';
import {useState} from 'react';
import {useUserClaims} from '../hooks/useUserClaims';
import {RoutePath} from '../lib/enums';
import {LOGOUT_URL} from '../utils/constants';
import {UaButton, UaDialog} from 'uppsala.ui.react';

const AbortBooking = () => {
  const {userClaims} = useUserClaims();
  const clearState = useBookingState((state) => state.clearState);

  const [showCancelBookingWarning, setShowCancelBookingWarning] = useState(false);

  const handleAbort = () => {
    clearState();
    if (userClaims) {
      const returnUrl = `${window.location.host}${RoutePath.LogoutPage}`;
      const url = `${LOGOUT_URL}?returnUrl=${returnUrl}`;
      if (!url) throw new Error('LOGOUT_URL was undefined');

      // Clear fake login sessionStorage if it exists
      sessionStorage.removeItem('fakeLoggedIn');
      sessionStorage.removeItem('mockedPIN');

      window.location.href = url;
    }
  };

  return (
    <>
      <UaButton
        type="secondary"
        title={t(userClaims ? 'button.cancelAndLogout' : 'button.cancel')}
        onClick={() => {
          setShowCancelBookingWarning(true);
          window.scrollTo(0, 0);
        }}
      />
      <UaDialog
        style={{minWidth: '400px'}}
        visible={showCancelBookingWarning}
        onCancel={() => setShowCancelBookingWarning(false)}
        title={t('message.abortBookingConfirmation')}
        cancelText={t('button.no') ?? 'Avbryt'}
        okText={t('button.yes') ?? 'Ja'}
        onOk={handleAbort}
      />
    </>
  );
};

export default AbortBooking;
